const getColorFromLevel = ({ theme }) => {
  return theme.colors.buttonPrimary;
};

export default getColorFromLevel;
